"use strict";

exports.__esModule = true;
exports.AppList = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _Theme = require("../../Theme");
var _System = require("../../../System");
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _AppIcon = require("../AppIcon");
var _EnvContext = require("../../Env/EnvContext");
var _getPartnerUrls = _interopRequireDefault(require("../../LandingScreen/ElevateSettingsMenu/getPartnerUrls"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "AppList__Container",
  componentId: "sc-1kfnbpq-0"
})(["flex:0;display:grid;grid-template-columns:1fr 1fr 1fr;grid-row-gap:20px;text-align:center;"]);
var AppListLink = (0, _styledComponents["default"])(_reactRouterDom.NavLink).withConfig({
  displayName: "AppList__AppListLink",
  componentId: "sc-1kfnbpq-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;color:", ";transition:transform 0.1s ease;&:hover{text-decoration:none;color:", ";transform:scale(1.3);}"], (0, _Theme.val)("AppHomeScreenColor"), (0, _Theme.val)("AppHomeScreenColor"));
var AppListAnchor = AppListLink.withComponent("a");
var AppListIcon = (0, _styledComponents["default"])(_AppIcon.AppIcon).withConfig({
  displayName: "AppList__AppListIcon",
  componentId: "sc-1kfnbpq-2"
})(["width:96px;height:96px;"]);
var AppListLabel = _styledComponents["default"].span.withConfig({
  displayName: "AppList__AppListLabel",
  componentId: "sc-1kfnbpq-3"
})(["font-size:1.2rem;margin:0;color:", ";"], (0, _Theme.val)("AppHomeScreenColor"));
var AppList = exports.AppList = (0, _styledComponents.withTheme)(function (_ref) {
  var children = _ref.children;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var env = useContext(_EnvContext.EnvContext);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "AppList"
  }, /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_DASHBOARDS"
  }, /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("DashboardList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "dashboards",
    alt: "dashboards"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.dashboards.title", "Dashboards")))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_DASHBOARDS"
  }, /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("ReportList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "reports",
    alt: "reports"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.reports.title", "Reports")))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_OPERATOR_PANELS"
  }, /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("OperatorPanelList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "operator",
    alt: "operator"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.operatorPanel.title", "Operator Panel")))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_ALERT"
  }, /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("AlertList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "alerts",
    alt: "alerts"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.alerts.title", "Alerts"))), " "), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_TICKETING"
  }, /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("TicketList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "tickets",
    alt: "tickets"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.tickets.title", "Tickets"))), " "), /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("WorkInstructionList")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "knowledgebase",
    alt: "knowledgeBase"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.workInstructions.title", "Knowledge Base"))), /*#__PURE__*/_react["default"].createElement(AppListLink, {
    to: (0, _System.getScreenLocation)("ExportDeviceData")
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "exportDeviceData",
    alt: "exportDeviceData"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.exportDeviceData.title", "Download Device Data"))), /*#__PURE__*/_react["default"].createElement(AppListAnchor, {
    href: (0, _getPartnerUrls["default"])(env, "documentationUrl"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(AppListIcon, {
    name: "docs",
    alt: "docs"
  }), /*#__PURE__*/_react["default"].createElement(AppListLabel, null, translate("AppList.docs.title", "Docs"))), children);
});